import BaseTracker from "./BaseTracker";
import type {Tracking} from "../../models/Tracking";
import type {Product} from "../../models/Product";
import {getEtCommerceOrder, getEtCommerceProduct} from "../eTrackerUtil";
import type {OrderReducerState} from "../../reducers/orderReducer";
import type {CouponReducerState} from "../../reducers/couponReducer";

export const trackerName = "slTracker";

export default class ETracker extends BaseTracker implements Tracking {
	constructor(trackingId: string, withEcommerce: boolean = false) {
		super(trackingId, withEcommerce);
	}

	addItem(product: Product, amount: number = 1) {
		const etCommerceProduct = getEtCommerceProduct(product);
		window.etCommerce.sendEvent("insertToBasket", etCommerceProduct, amount);
	}

	removeItem(product: Product, amount: number = 1) {
		const etCommerceProduct = getEtCommerceProduct(product);
		window.etCommerce.sendEvent("removeFromBasket", etCommerceProduct, amount);
	}

	logOrder(order: OrderReducerState, coupon: ?CouponReducerState) {
		const etCommerceOrder = getEtCommerceOrder(order, coupon);
		window.etCommerce.sendEvent("order", etCommerceOrder);
	}

	insertToWatchlist(product: Product) {
		const etCommerceProduct = getEtCommerceProduct(product);
		window.etCommerce.sendEvent("insertToWatchlist", etCommerceProduct, 1);
	}

	removeFromWatchlist(product: Product) {
		const etCommerceProduct = getEtCommerceProduct(product);
		window.etCommerce.sendEvent("removeFromWatchlist", etCommerceProduct, 1);
	}

	showProductDetails(product: Product) {
		const etCommerceProduct = getEtCommerceProduct(product);
		window.etCommerce.sendEvent("viewProduct", etCommerceProduct, "1");
	}
}
